// Required until there is wider support for https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause

export interface NestedError extends Error {
  readonly innerError: Error;
}

export function isNestedError(error: Error): error is NestedError {
  return (error as NestedError).innerError !== undefined;
}
